import React from 'react';
import NlimsDataTable from '../../shared/NlimsDataTable/NlimsDataTable';
import { outbreakRecordsApi } from '../../../api/animalHealthApi';
import { useAnimalHealthRecords } from '../hooks/useAnimalHealthRecords';

const ALERT_STYLE = {
  Confirmed: 'background:#fff1f2;color:#be123c;border:1px solid #fecdd3;',
  Suspected: 'background:#fef3c7;color:#b45309;border:1px solid #fcd34d;',
  'Under Investigation': 'background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;',
};

function alertHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const s = ALERT_STYLE[data] || 'background:#f3f4f6;color:#6b7280;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${s}">${data || '-'}</span>`;
}

const COLUMNS = [
  { title: 'Outbreak Reference', data: 'outbreakRef', sortable: true },
  { title: 'Pathogen', data: 'pathogen', sortable: true },
  { title: 'Start Date', data: 'startDate', sortable: true },
  { title: 'End Date', data: 'endDate', sortable: true },
  { title: 'State Affected', data: 'stateAffected', sortable: true },
  { title: 'LGAs Affected', data: 'lgasAffected', sortable: true },
  { title: 'Total Cases', data: 'totalCases', sortable: true },
  { title: 'Total Deaths', data: 'totalDeaths', sortable: true },
  { title: 'Response Actions Taken', data: 'responseActions', sortable: true },
  { title: 'Zoonotic Risk Flag', data: 'zoonoticRiskFlag', sortable: true },
  { title: 'Economic Loss Estimate (NGN)', data: 'economicLoss', sortable: true },
  { title: 'Alert Level', data: 'alertLevel', sortable: true, render: alertHtml },
];

export default function OutbreakRecordsTab({ searchQuery = '' }) {
  const { filteredRecords, loading, error } = useAnimalHealthRecords(outbreakRecordsApi, searchQuery);

  return (
    <div className="space-y-3">
      {loading && (
        <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-700">
          Loading outbreak records...
        </div>
      )}
      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}
      <NlimsDataTable
        tableId="outbreak-records-table"
        columns={COLUMNS}
        data={filteredRecords}
        serverSide={false}
        hideSearch
        pageLength={10}
        enableRowSelection
      />
    </div>
  );
}
